import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Sometimes I do graph by hand as well. This post is to mock the manga artists I like when growing up and apply their drawing skill to Final Fantasy 7 to see how their style adapt to new story...`}</p>
    <h1>{`Requirement`}</h1>
    <p>{`A decent knowledge of 80s manga, anime and Japan RPG video game. `}</p>
    <h1>{`Covid-19 At Home 24 Days`}</h1>
    <p>{`Final Fatansy 7 Remake inspired this test idea. `}<a parentName="p" {...{
        "href": "https://cdn-prod.scalefast.com/public/assets/img/resized/squareenix-store-v3/46f45ae4ab4eccc1c7ad7a83d2abfb7d_1920_KR.jpg"
      }}>{`Here`}</a>{`'re the main characters.`}</p>
    <p>{`Now here comes my `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`hand drawing`}</code>{` dump:`}</p>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/dcfff5b0066c58dba35a2facd13edb55/d2602/slam_dunk.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75.33333333333333%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAIF/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAB1YCgf//EABYQAQEBAAAAAAAAAAAAAAAAAAEAEP/aAAgBAQABBQKXGM//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAUEAEAAAAAAAAAAAAAAAAAAAAg/9oACAEBAAY/Al//xAAZEAACAwEAAAAAAAAAAAAAAAAAEQEQQWH/2gAIAQEAAT8hxDFXBCE6/9oADAMBAAIAAwAAABAwD//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABkQAAMBAQEAAAAAAAAAAAAAAAABESExQf/aAAgBAQABPxBzBpNmjeODRueqXI1OCiP/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Slam Dunk FF7",
            "title": "Slam Dunk FF7",
            "src": "/static/dcfff5b0066c58dba35a2facd13edb55/b4294/slam_dunk.jpg",
            "srcSet": ["/static/dcfff5b0066c58dba35a2facd13edb55/75985/slam_dunk.jpg 150w", "/static/dcfff5b0066c58dba35a2facd13edb55/f93b5/slam_dunk.jpg 300w", "/static/dcfff5b0066c58dba35a2facd13edb55/b4294/slam_dunk.jpg 600w", "/static/dcfff5b0066c58dba35a2facd13edb55/8e1fc/slam_dunk.jpg 900w", "/static/dcfff5b0066c58dba35a2facd13edb55/e5166/slam_dunk.jpg 1200w", "/static/dcfff5b0066c58dba35a2facd13edb55/d2602/slam_dunk.jpg 4032w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Slam Dunk FF7`}</figcaption>{`
  `}</figure>


    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/12a8a3ccca6b6d28de0e106807c3cdb0/d2602/captain_dakongyi.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75.33333333333333%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAECBf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAeri0A//xAAUEAEAAAAAAAAAAAAAAAAAAAAg/9oACAEBAAEFAl//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAUEAEAAAAAAAAAAAAAAAAAAAAg/9oACAEBAAY/Al//xAAZEAACAwEAAAAAAAAAAAAAAAAAARARMSH/2gAIAQEAAT8heF9UMWR//9oADAMBAAIAAwAAABBgD//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABkQAAMBAQEAAAAAAAAAAAAAAAERIQAxEP/aAAgBAQABPxAgEdzcI+nEajjdC+f/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Captain Tsubasa FF7",
            "title": "Captain Tsubasa FF7",
            "src": "/static/12a8a3ccca6b6d28de0e106807c3cdb0/b4294/captain_dakongyi.jpg",
            "srcSet": ["/static/12a8a3ccca6b6d28de0e106807c3cdb0/75985/captain_dakongyi.jpg 150w", "/static/12a8a3ccca6b6d28de0e106807c3cdb0/f93b5/captain_dakongyi.jpg 300w", "/static/12a8a3ccca6b6d28de0e106807c3cdb0/b4294/captain_dakongyi.jpg 600w", "/static/12a8a3ccca6b6d28de0e106807c3cdb0/8e1fc/captain_dakongyi.jpg 900w", "/static/12a8a3ccca6b6d28de0e106807c3cdb0/e5166/captain_dakongyi.jpg 1200w", "/static/12a8a3ccca6b6d28de0e106807c3cdb0/d2602/captain_dakongyi.jpg 4032w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Captain Tsubasa FF7`}</figcaption>{`
  `}</figure>


    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/45ccb228b0f6483435b5545da2f3fb40/d2602/doramon.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75.33333333333333%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAAMAAAAAAAAAAAAAAAAAAAECBf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAdWoEj//xAAWEAEBAQAAAAAAAAAAAAAAAAABECD/2gAIAQEAAQUCcE//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAUEAEAAAAAAAAAAAAAAAAAAAAg/9oACAEBAAY/Al//xAAZEAACAwEAAAAAAAAAAAAAAAAAARARIWH/2gAIAQEAAT8hbC+w9EUf/9oADAMBAAIAAwAAABCjz//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABkQAQADAQEAAAAAAAAAAAAAAAEAETFRIf/aAAgBAQABPxAinYJHrLjdxOIr3eRCf//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Doraemon FF7",
            "title": "Doraemon FF7",
            "src": "/static/45ccb228b0f6483435b5545da2f3fb40/b4294/doramon.jpg",
            "srcSet": ["/static/45ccb228b0f6483435b5545da2f3fb40/75985/doramon.jpg 150w", "/static/45ccb228b0f6483435b5545da2f3fb40/f93b5/doramon.jpg 300w", "/static/45ccb228b0f6483435b5545da2f3fb40/b4294/doramon.jpg 600w", "/static/45ccb228b0f6483435b5545da2f3fb40/8e1fc/doramon.jpg 900w", "/static/45ccb228b0f6483435b5545da2f3fb40/e5166/doramon.jpg 1200w", "/static/45ccb228b0f6483435b5545da2f3fb40/d2602/doramon.jpg 4032w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Doraemon FF7`}</figcaption>{`
  `}</figure>


    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/406d9a1398a21d52ef383d357558d474/d2602/saint_seiya.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75.33333333333333%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAIBAwX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHVrZSQD//EABYQAAMAAAAAAAAAAAAAAAAAAAAgQf/aAAgBAQABBQIqf//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABQQAQAAAAAAAAAAAAAAAAAAACD/2gAIAQEABj8CX//EABkQAQACAwAAAAAAAAAAAAAAAAEQIQARMf/aAAgBAQABPyFdGDS5e1H/2gAMAwEAAgADAAAAEDPP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAGhABAQEBAAMAAAAAAAAAAAAAAREAIRAxQf/aAAgBAQABPxASPrkZBI2Zl1GcwnIL7fH/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Saint Seiya FF7",
            "title": "Saint Seiya FF7",
            "src": "/static/406d9a1398a21d52ef383d357558d474/b4294/saint_seiya.jpg",
            "srcSet": ["/static/406d9a1398a21d52ef383d357558d474/75985/saint_seiya.jpg 150w", "/static/406d9a1398a21d52ef383d357558d474/f93b5/saint_seiya.jpg 300w", "/static/406d9a1398a21d52ef383d357558d474/b4294/saint_seiya.jpg 600w", "/static/406d9a1398a21d52ef383d357558d474/8e1fc/saint_seiya.jpg 900w", "/static/406d9a1398a21d52ef383d357558d474/e5166/saint_seiya.jpg 1200w", "/static/406d9a1398a21d52ef383d357558d474/d2602/saint_seiya.jpg 4032w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Saint Seiya FF7`}</figcaption>{`
  `}</figure>


    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/07b72a188ef23b2576334bfb9c344fe6/d2602/dragon_ball.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75.33333333333333%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAECAwX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHrZuChB//EABYQAAMAAAAAAAAAAAAAAAAAAAEQIP/aAAgBAQABBQJGP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABQQAQAAAAAAAAAAAAAAAAAAACD/2gAIAQEABj8CX//EABkQAAMBAQEAAAAAAAAAAAAAAAABESExEP/aAAgBAQABPyGrgnl8O5B3hcR//9oADAMBAAIAAwAAABBzz//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABsQAQEBAAIDAAAAAAAAAAAAAAERACExQVFh/9oACAEBAAE/EPd5mIdKneFR+Z0AA9uurDqs8uE0AZON/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Dragon Ball FF7",
            "title": "Dragon Ball FF7",
            "src": "/static/07b72a188ef23b2576334bfb9c344fe6/b4294/dragon_ball.jpg",
            "srcSet": ["/static/07b72a188ef23b2576334bfb9c344fe6/75985/dragon_ball.jpg 150w", "/static/07b72a188ef23b2576334bfb9c344fe6/f93b5/dragon_ball.jpg 300w", "/static/07b72a188ef23b2576334bfb9c344fe6/b4294/dragon_ball.jpg 600w", "/static/07b72a188ef23b2576334bfb9c344fe6/8e1fc/dragon_ball.jpg 900w", "/static/07b72a188ef23b2576334bfb9c344fe6/e5166/dragon_ball.jpg 1200w", "/static/07b72a188ef23b2576334bfb9c344fe6/d2602/dragon_ball.jpg 4032w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Dragon Ball FF7`}</figcaption>{`
  `}</figure>
    <p>{`As you could see, artist `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Takehiko_Inoue"
      }}>{`Takehiko Inoue`}</a>{` is a clear win because of his realistic style. `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Fujiko_Fujio"
      }}>{`Fujiko Fujio`}</a>{` and `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Y%C5%8Dichi_Takahashi"
      }}>{`Yōichi Takahashi`}</a>{` struggles because they chose young kids appealing style.`}</p>
    <p><a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Masami_Kurumada"
      }}>{`Masami Kurumada`}</a>{` and `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Akira_Toriyama"
      }}>{`Akira Toriyama`}</a>{` are fine with the new story. Akira Toriyama's drawing is too stylish and you probably feel you are still watch the series e.g. Dragon Ball X or some Gaiden of Dragon Quest XVI.`}</p>
    <p>{`Note Masami Kurumada pay many attention to the metal armor while Takehiko Inoue focus on sweat of people and huge amount of details in face.`}</p>
    <p>{`Ok, made my day! How about you?😃`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      